import { ChangeEvent, useEffect, useState } from "react";
import useFirestore from "shared/hooks/useFirestore";
import useGetBranchId from "shared/hooks/useGetBranchId";

const useNoticeListView = (isBranch:boolean) => {
    const {getBranchId} = useGetBranchId();
    const { readFirestore } = useFirestore();
    const [search, setSearch] = useState<string>('');
    const [lists, setLists] = useState<any[]>([]);
    const [searchedLists, setSearchedLists] = useState<any[]>([]);
    useEffect(() => {
        getNoticeList();
        // eslint-disable-next-line
    }, [])

    const getNoticeList = async() => {
        const notice_list:any[] = [];
        const master_notice_list = await readFirestore('Notice/Master/All').then(res => {
            const list:any[] = [];
            const docs = res.docs;
            const docs_length = res.docs.length;
            for(let i = 0; i < docs_length; i++){
                const doc = docs[i];
                list.push({id:doc.id, ...doc.data()})
            }
            return list;
        })
        notice_list.push(...master_notice_list);
        if(isBranch){
            const branch_id = await getBranchId();
            const branch_notice_list = await readFirestore(`Notice/Branch/${branch_id}`).then(res => {
                const list:any[] = [];
                const docs = res.docs;
                const docs_length = res.docs.length;
                for(let i = 0; i < docs_length; i++){
                    const doc = docs[i];
                    list.push({id:doc.id, ...doc.data()})
                }
                return list;
            })
            notice_list.push(...branch_notice_list);
        }
        setLists(notice_list);
        setSearchedLists(notice_list);
    }

    const onChange = (e:ChangeEvent<HTMLInputElement>) => {
        setSearch(e.target.value);
    }

    const onRefreshClick = () => {
        setLists([]);
        setSearchedLists([]);
        getNoticeList();
    }

    useEffect(() => {
        const searchedItems = lists.filter((item) => item["title"].includes(search));
        setSearchedLists(searchedItems);
        // eslint-disable-next-line
    }, [search])

    return {search, searchedLists, onRefreshClick, onChange}
}

export default useNoticeListView;